import { SkeletonProps } from "@mui/material";
import { TailwindSkeleton as Skeleton } from "component-tailwind-skeletons";
import React, { FC } from "react";

export interface ImageSkeletonProps {
  aspectRatio: number | undefined;
  className?: string;
  variant?: SkeletonProps["variant"];
  animation?: "pulse" | "wave" | false;
  isDarkBg?: boolean;
  color?: string;
  height?: string;
  dataTestid?: string;
  style?: React.CSSProperties;
}

export const ImageSkeleton: FC<ImageSkeletonProps> = ({
  aspectRatio,
  className,
  variant = "rectangular",
  animation,
  isDarkBg,
  color,
  height,
  dataTestid
}) => {
  return (
    <Skeleton
      data-testid={dataTestid}
      variant={variant}
      className={className}
      animation={animation || false}
      style={{
        width: "100%",
        height: height ?? "100%",
        backgroundColor: color ?? (isDarkBg ? undefined : "#EBE7DF"),
        // @ts-ignore
        "--aspect-ratio": aspectRatio
      }}
    />
  );
};

export default ImageSkeleton;
